module.exports = __webpack_public_path__ + "img/upload_icon.72ec3d8d.svg";